import { FC } from 'react';
import styled from '@emotion/styled';
import { Text } from '@chakra-ui/react';
import { omitComponentProps } from '../utils/omitComponentProps';
import { primaryProps } from '../utils/primaryProps';

export const LinkStyled: FC<any> = styled(
  omitComponentProps(Text, ['primary']),
)`
  text-decoration: ${({ textDecoration }: any) =>
    textDecoration || `underline`};
  cursor: ${({ cursor }: any) => cursor || `pointer`};
  ${primaryProps};
`;
